import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  private showHideSubject = new BehaviorSubject<boolean>(false);

  // Observable to expose the variable
  isMobile$ = this.showHideSubject.asObservable();

  constructor() {}

  // Method to set the variable
  setShowHide(value: boolean): void {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
 
    if(width < 768)
    {
      //this.isMobile = true;
      this.showHideSubject.next(true);
    }
      else
    {
     // this.isMobile = false;
      this.showHideSubject.next(false);
    }

   // this.showHideSubject.next(true);
  }

  // Method to get the current value
  getShowHide(): boolean {
    return this.showHideSubject.getValue();
  }
}
